<div class="header-wrapper grid justify-items-start items-center gap-2">
  <sbnb-icon icon="left-arrow" class="arrow cursor-pointer" [routerLink]="['/direct']"></sbnb-icon>

  <h2 class="input__editable nomargin">
    <span #nameSpan style="padding-left: 0; padding-right: 8px; visibility: hidden; position: absolute; left: -9999px">
      {{ title }}
    </span>

    <input
      class="input__borderless"
      style="color: #230b41"
      type="text"
      [style.width.px]="nameSpan.getBoundingClientRect().width"
      [(ngModel)]="title"
      (change)="saveTitle()" />
  </h2>

  <span
    class="badge text-center"
    [class.badge-lemon]="!directEditService.isPublished"
    [class.badge-grass]="directEditService.isPublished">
    {{ directEditService.site.publish_status | friendlyPublishStatus }}
  </span>

  <div class="actions grid grid-flow-col gap-2">
    <ng-container *ngIf="directEditService.isPublished">
      <sbnb-button
        label="Unpublish"
        size="mini"
        type="secondary"
        (click)="directEditService.unpublishSite()"></sbnb-button>

      <sbnb-button label="Visit site" size="mini" (click)="directEditService.openSite()"></sbnb-button>
    </ng-container>

    <ng-container *ngIf="!directEditService.isPublished">
      <sbnb-button label="Preview" size="mini" type="secondary" (click)="directEditService.openPreview()"></sbnb-button>

      <sbnb-button
        label="Publish now"
        size="mini"
        [loading]="directEditService.publishing"
        (click)="directEditService.publishSite()"></sbnb-button>
    </ng-container>
  </div>

  <div class="save-status h-6">
    <sbnb-save-indicator class="grid" [saveStatus]="saveStatus"></sbnb-save-indicator>
  </div>
</div>
